/**
 * Fill missing order-tenant logos from the IAM picker list. Admin order rows
 * historically shipped `logoUrl: null` for uploaded logos; the picker already
 * has the signed URL for the same tenant.
 */
export function applyTenantPickerLogos<
  T extends { tenant: { id: string; logoUrl?: string | null } },
>(
  orders: T[],
  tenants: ReadonlyArray<{ id: string; logoUrl?: string | null }>,
): T[] {
  if (orders.length === 0 || tenants.length === 0) return orders;

  const logoByTenantId = new Map(
    tenants.map((tenant) => [tenant.id, tenant.logoUrl ?? null]),
  );

  return orders.map((order) => {
    if (order.tenant.logoUrl) return order;
    const pickerLogo = logoByTenantId.get(order.tenant.id);
    if (!pickerLogo) return order;
    return {
      ...order,
      tenant: { ...order.tenant, logoUrl: pickerLogo },
    };
  });
}
